import { render } from "./HomepageHero.vue?vue&type=template&id=e9a00a76"
import script from "./HomepageHero.vue?vue&type=script&lang=js"
export * from "./HomepageHero.vue?vue&type=script&lang=js"

import exportComponent from "/Users/MearnsGill/Sites/ICoTA/icota-europe.localhost/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__